/* Add-on sections: the only script in the library, and it only drives the
   reasons carousel's arrows and position dots, and the dots on swiping icon cards. The row itself is native scroll-snap, so it swipes
   and keyboard-scrolls with this file absent.

   Every carousel section (and icon cards set to swipe) emits a <script> tag for this file, so it can run more
   than once on a page. The guard below makes that harmless. */
(function () {
  'use strict';
  if (window.__lpXLoaded) return;
  window.__lpXLoaded = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.__lpX) return;
    root.__lpX = true;

    var track = root.querySelector('[data-lp-x-track]');
    if (!track) return;
    var nav = root.querySelector('[data-lp-x-nav]');
    var prev = nav && nav.querySelector('[data-lp-x-prev]');
    var next = nav && nav.querySelector('[data-lp-x-next]');
    var dotsBox = root.querySelector('[data-lp-x-dots]');
    var dots = dotsBox ? dotsBox.children : [];

    /* One card plus the gap: the distance an arrow press moves. */
    function step() {
      var slide = track.querySelector('[data-lp-x-slide]');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (nav) {
        /* Arrows that can do nothing are noise. When every card fits, hide them. */
        nav.hidden = max <= 2;
        prev.disabled = x <= 2;
        next.disabled = x >= max - 2;
      }
      if (dots.length) {
        /* The last card can never snap to the left edge, so reaching the end of
           the row lights the last dot rather than whichever card is leftmost. */
        var i = x >= max - 2 ? dots.length - 1 : Math.round(x / step());
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      }
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
    }

    if (nav) {
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);

    update();
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-lp-x-carousel]');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor: a re-rendered section arrives as fresh markup. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Theme editor: selecting a card in the sidebar scrolls it into view. */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-lp-x-slide]');
    if (!slide) return;
    var track = slide.closest('[data-lp-x-track]');
    var first = track.querySelector('[data-lp-x-slide]');
    track.scrollTo({ left: slide.offsetLeft - first.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
  });
})();
